<template>
  <div @drop="onDrop(null, $event)" @dragover.prevent @dragenter.prevent>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent width="350">
        <v-card>
          <v-card-title class="headline">Learning Course Delete</v-card-title>
          <v-card-text
            >If you delete this course template, it is gone for good. Delete
            only if you are sure.</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="dangerous-action-btn" @click="deleteItem()"
              >Delete</v-btn
            >
            <v-btn class="cancel-action-btn" @click="dialog = false"
              >Cancel</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <v-sheet>
      <div class="d-flex justify-end">
        <v-btn
          id="js-grid-add-button"
          class="default-action-btn"
          @click="overlay = true"
          small
        >
          Add
        </v-btn>
      </div>
      <div class="border">
        <div class="inner-border"><p></p></div>
        <v-overlay :value="folderOverlay" class="d-flex" :dark="true">
          <div class="d-flex justify-end">
            <v-btn icon @click="folderOverlay = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
          <v-card light max-width="850" min-width="500">
            <v-card-text>
              <div class="overline">folder</div>
              <div class="ma-4">
                <v-row>
                  <v-col>
                    <v-text-field
                      outlined
                      single-line
                      dense
                      hide-details
                      id="js-document-folder"
                      v-model="folderCourse.folder"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2"
                    ><v-btn class="default-action-btn" @click="saveFolder"
                      >save</v-btn
                    ></v-col
                  >
                </v-row>
                <v-row>
                  <p>
                    Add new or existing folder name. Clear folder name to remove
                    from folder.
                  </p>
                </v-row>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-btn class="default-action-btn" @click="folderOverlay = false">
                close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-overlay>

        <v-sheet id="js-folder-tree" class="ma-4 pa-6">
          <v-progress-linear
            id="js-tree-loader"
            v-if="loadingTree"
            active
            height="4"
            indeterminate
          ></v-progress-linear>
          <template>
            <v-treeview
              :items="treeItems"
              dense
              expand-icon=""
              open-on-click
              transition
              return-object
            >
              <template slot="label" slot-scope="{ item }">
                <a
                  draggable
                  :class="draggableClasses(item)"
                  @click="goToCourse(item)"
                  @contextmenu="editFolder(item, $event)"
                  @dragstart="startDrag(item, $event)"
                  @drop="onDrop(item, $event)"
                  @dragover.prevent
                  @dragenter="hoverFolder = item.name"
                  >{{ item.name }}</a
                >
              </template>
              <template v-slot:prepend="{ item, open }">
                <v-icon color="secondary" v-if="item.children">
                  {{ open ? "mdi-folder-open" : "mdi-folder" }}
                </v-icon>
              </template></v-treeview
            >
          </template>
        </v-sheet>
        <p class="note">
          drag course titles into existing folders to move the course to the
          folder
        </p>
        <p class="note">
          drag course titles out of folder area to remove from all folders
        </p>
        <p class="note">
          right click course titles to create a new folder for the course
        </p>
      </div>
      <v-overlay :value="overlay" class="d-flex" :dark="false">
        <div class="d-flex justify-end">
          <v-btn icon @click="overlay = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <add-new-course v-on:close:overlay="overlay = false"></add-new-course>
      </v-overlay>
      <p>
        <v-icon>mdi-shield-star-outline</v-icon> Until we find a better place to
        put it, the badge library can be found
        <router-link
          class="nav-link"
          active-class="nav-link-active"
          :to="{ name: 'BadgeList' }"
        >
          here
        </router-link>
      </p>
      <p>
        <v-icon>mdi-shield-star-outline</v-icon> All the individual items in
        templates can be seen
        <router-link
          class="nav-link"
          active-class="nav-link-active"
          :to="{ name: 'LearningItemsManager' }"
        >
          here
        </router-link>
      </p>
    </v-sheet>
  </div>
</template>

<script>
import titleMixin from "@/mixins/titleMixin"
import BaseBadge from "@/components/BaseBadge"
import BaseGrid from "@/components/BaseGrid"
import AddNewCourse from "@/containers/learnings/AddNewCourse"
import { mapGetters } from "vuex"

export default {
  mixins: [titleMixin],
  components: {
    BaseBadge,
    BaseGrid,
    AddNewCourse
  },
  data: function() {
    return {
      overlay: false,
      title: "Learning Course Templates",
      dialog: false,
      deleteItemId: 0,
      folderOverlay: false,
      treeItems: [],
      loadingTree: true,
      folderCourse: {},
      isDragging: false,
      hoverFolder: ""
    }
  },
  watch: {
    courses: function(newValue, oldValue) {
      this.putItemsInTree()
    }
  },
  computed: {
    ...mapGetters("courses", {
      courses: "getTemplates"
    }),
    badgeIds() {
      return this.courses.map((el, index) => `js-course-grid-${index + 1}`)
    },
    imageUrls() {
      return this.courses.map(el => el.badge_url)
    },
    badgeIcons() {
      return Array(this.courses.length).fill("mdi-close")
    },
    badgeColors() {
      // 3c807e
      return Array(this.courses.length).fill("#bba782")
    }
  },
  created() {
    this.$store.dispatch("courses/loadTemplates")
  },

  methods: {
    startDrag(item, evt) {
      this.isDragging = true
      evt.dataTransfer.dropEffect = "move"
      evt.dataTransfer.effectAllowed = "move"
      evt.dataTransfer.setData("itemId", item.id)
    },
    onDrop(targetItem, evt) {
      this.isDragging = false
      this.hoverFolder = ""
      const draggingItemId = evt.dataTransfer.getData("itemId")
      if (draggingItemId !== "undefined") {
        if (!targetItem) {
          this.loadingTree = true
          this.$store.dispatch("courses/updateCourse", {
            id: draggingItemId,
            folder: ""
          })
        } else {
          let folder = targetItem.name
          if (!targetItem.children) {
            folder = targetItem.folder
          }
          this.loadingTree = true
          this.$store.dispatch("courses/updateCourse", {
            id: draggingItemId,
            folder: folder
          })
        }
      }
    },
    draggableClasses(item) {
      let s = "tree-item"
      if (item.children) {
        s = s + " tree-folder-item"
      }

      if (item.children) {
        if (this.hoverFolder == item.name) {
          s = s + " this-one"
        }
      } else {
        if (item.folder != "" && this.hoverFolder == item.folder) {
          s = s + " this-one"
        }
      }

      return s
    },
    editFolder(item, e) {
      e.preventDefault()
      if (!item.children) {
        this.folderCourse = item
        this.folderOverlay = true
      }
    },
    putItemsInTree() {
      this.loadingTree = true
      this.treeItems.splice(0, this.treeItems.length)

      this.courses.forEach(course => {
        if (course.folder.length > 0) {
          let foundFolder = false
          let folderName = course.folder
          this.treeItems.forEach(treeItem => {
            if (treeItem.children && treeItem.name == folderName) {
              foundFolder = true
              treeItem.children.push(course)
            }
          })

          if (!foundFolder) {
            this.treeItems.push({
              name: folderName,
              children: [course]
            })
          }
        } else {
          this.treeItems.push(course)
        }

        this.treeItems = [...this.treeItems].sort((a, b) => {
          if (a.name.toUpperCase() > b.name.toUpperCase()) return 1
          if (b.name.toUpperCase() > a.name.toUpperCase()) return -1

          return 0
        })
      })
      this.loadingTree = false
    },
    goToCourse(item) {
      if (!item.children) {
        this.$router.push({
          name: "coursesManager",
          params: { id: item.id },
          query: { edit: true }
        })
      }
    },
    saveFolder() {
      this.folderOverlay = false
      this.loadingTree = true
      this.$store.dispatch("courses/updateCourse", {
        id: this.folderCourse.id,
        folder: this.folderCourse.folder
      })
    },
    confirmDeleteItem(itemId) {
      this.deleteItemId = itemId
      this.dialog = true
    },
    deleteItem() {
      this.dialog = false
      this.$store.dispatch("courses/deleteCourse", this.deleteItemId)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";
@import "../../scss/course-grid";

.note {
  padding: 0px 30px;
  font-style: italic;
}

.border {
  margin: 20px 0px;
}

.tree-item {
  color: $very-dark-grey;
  font-size: 1.4em;
  line-height: 2.2em;
  padding: 5px 20px 5px 5px;
}

.dragging-target {
  border: 2px dashed $light-yellow;
  border-radius: 7px;
}

.tree-folder-item {
  font-weight: bold;
}

.this-one {
  font-style: italic;
  font-weight: bold;
}
</style>
